import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class BorrarAppService {

    static deleteApp(businessId, deleteUrl){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(deleteUrl, { uid: uid, token: token, businessId: businessId}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-app-modal/services/borrarAppService.js